import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpErrorResponse
} from '@angular/common/http';

import { Observable, catchError, of, throwError } from 'rxjs';
import { toastRequestUnauthorized } from "@nstep-common/utils";
import { AuthService } from '@nstep-common/core';
import { SessionService } from 'projects/common/core/services/auth/session.service';

const authFailureIgnoredUrls = [
	'api/account/log-out',
	'api/account/refresh'
];

const activityIgnoredUrls = [
	'api/metrics',
	'api/collection',
	'api/logs'
];

const ignoredUrls = [...authFailureIgnoredUrls, ...activityIgnoredUrls];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	constructor(private authService: AuthService,
		private sessionService: SessionService
	) { }

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const accessToken = this.sessionService.getAccessToken();
		if (accessToken) {
			request = request.clone({
				headers: request.headers.set('Authorization', `Bearer ${accessToken}`)
			});
		}

		const activityUpdateIgnored = ignoredUrls.some(url => request.url.endsWith(url));
		const authFailureIgnored = authFailureIgnoredUrls.some(url => request.url.endsWith(url));

		if (!activityUpdateIgnored) {
			this.authService.updateLastRequest();
		}

		return next.handle(request).pipe(catchError(err => {
			if (!(err instanceof HttpErrorResponse)) {
				return throwError(() => err);
			}

			const unauthorized = this.isUnauthorized(err);
			if (!authFailureIgnored && (unauthorized || this.terminatesSession(err))) {
				if (unauthorized) {
					toastRequestUnauthorized(err.status);
				}

				this.authService.logOut();
			}

			if (unauthorized) {
				return of();
			}

			return throwError(() => err);
		}));
	}

	private isUnauthorized(error: HttpErrorResponse): boolean {
		return error.status === 401 || error.status === 403;
	}

	private terminatesSession(error: HttpErrorResponse): boolean {
		return error.status === 0 || error.status >= 500;
	}
}
